import { apiSlice } from "../API/apiSlice";

const taskApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: () => "/tasks",
    }),
    getTask: builder.query({
      query:(tid)=> `/tasks/${tid}`
    }),
    editTaskStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `tasks/${id}`,
        method: "PATCH",
        body: {
          status,
        },
      }),
    }),
    
    deleteTask: builder.mutation({
      query: (id) => ({
        url: `/tasks/${id}`,
        method: "DELETE",
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // optimistic cache update START
        const patchResult = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            return (draft = draft.filter((t) => t.id != arg));
          })
        );
        queryFulfilled.catch(patchResult.undo);
        // optimistic cache update END
      },
    }),
    // Add Taks
    addTask: builder.mutation({
      query: (data) => ({
        url: "/tasks",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            taskApi.util.updateQueryData("getTasks", undefined, (draft) => {
              draft.push(data);
            })
          );
        } catch (error) {
          console.log("Error: ", error.message);
        }
      },
    }),
    // Edit Task
    editTask: builder.mutation({
      query: ({data, id}) => ({
        url: `/tasks/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, arg)=>[{type:'task', id:arg.id}],
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            taskApi.util.updateQueryData("getTasks", undefined, (draft) => {
              const m = draft.find(d=>d.id == data.id)
              m.deadline= data.deadline
              m.taskName = data.taskName
              m.teamMember = data.teamMember
              m.project= data.project
              m.status = data.status
            })
          );
        } catch (error) {
          console.log("Error: ", error.message);
        }
      },
    })
  }),
});

export const {
  useGetTasksQuery,
  useGetTaskQuery,
  useEditTaskStatusMutation,
  useDeleteTaskMutation,
  useAddTaskMutation,
  useEditTaskMutation,
} = taskApi;
